// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__346Hd","title":"BackImages_title__2xU2Q","images":"BackImages_images__246pA"};